/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import JsController from '../../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'live-chat-monitoring');
    controller.addMountFunction(() => {
        mountComponent(controller);
    })

    return controller.init();
}


// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-explicit-any
declare let LCM: any;

function hideLcmButton()
{
    const se:any = document.createElement('script'); 
    se.type = 'text/javascript';
    se.async = true;
    se.src = '//storage.googleapis.com/livechatmonitoring/js/fdeea3cd-dce4-407a-82b8-fdbd21e10562.js';
    let done = false;
    se.onload = se.onreadystatechange = function () {
        if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
            done = true;
            LCM.hideButton();
        }
    };

    let s = document.getElementsByTagName('script')[0]; s.parentNode?.insertBefore(se, s);
}

export function mountComponent( controller: JsController ) {
    const element = document.querySelector<HTMLElement>('#live-chat-monitoring');
    const script = document.createElement('script')
    script.src = 'https://www.widgetinstall.com/plugin/chat.js?rand='+Math.random()
    script.id= 'chat_js_lib';
    script.dataset.key='72ZBah4PK4n13A146SGC';
    // now append the script into HEAD, it will fetched and executed
    if(element){
        element.append(script);
        if(element?.dataset.hideButton==='true')
        {
            hideLcmButton();
        }
    }
}

